module.exports = __webpack_public_path__ + "static/media/Outdoor.17a19870.jpg";